<app-base-layout [darkMode]="false" [showFooter]="true"
  >

  <form [formGroup]="formGroup" (ngSubmit)="changeStep()" class="form-next">
    <h1 class="form-next-title">Bem vindo!</h1>
    <h2 class="form-next-description" [innerHTML]="this.description"></h2>
    <mat-spinner [diameter]="50" *ngIf="isLoading"></mat-spinner>
    <ng-container   *ngIf="!isLoading">
      <app-dynamic-input
      [campo]="campoDocumento"
      [formGroup]="formGroup"
      class="dynamic-input"
    
    ></app-dynamic-input>
    </ng-container>
    <button
      *ngIf="isValid()"
      type="submit"
      [disabled]="!isValid() || isSubmited"
      class="btn-avancar"
    >
      Continuar
      <mat-icon aria-hidden="false" aria-label="Avançar"
        >navigate_next</mat-icon
      >
    </button>

  </form>
</app-base-layout>
